import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import IAsyncModel from "models/IAsyncModel";
import amnPosApi from "api/amnPosApi";
import IPosProperties from "adminPanel/pos/models/IPosProperties";
import { EmptyPosProperties } from "adminPanel/pos/models/IPosProperties";

export interface PosSettingSlice extends IAsyncModel, IPosProperties {}

const initialState: PosSettingSlice = EmptyPosProperties;
export const getPosSettingAsync = createAsyncThunk(
  "pos/PosSetting",
  async (posId: string) => {
    const resp = await amnPosApi.GetPosSetting(posId);
    return {
      id: resp.data.id,
      numberingPrefix: resp.data.numberingPrefix,
      localizations: resp.data.localizations,
      updatedOn: resp.data.updatedOn,
      store: resp.data.store,
      users: resp.data.users,
      storeInfo: resp.data.storeInfo,
      useFullService: resp.data.useFullService,
      currencies: resp.data.currencies,
      bankCards: resp.data.bankCards,
      returnOptions: resp.data.returnOptions,
      ordersOptions: resp.data.ordersOptions,
      roundOptions: resp.data.roundOptions,
      settleOptions: resp.data.settleOptions,
      posPrintDesigns: resp.data.posPrintDesigns,
      printingServiceUrl: resp.data.printingServiceUrl,
      storeId: resp.data.storeId,
      callerID: resp.data.callerID,
      isPosHasSupervisors: resp.data.isPosHasSupervisors,
    } as IPosProperties;
  }
);

export const posSettingSlice = createSlice({
  name: "posSetting",
  initialState,
  reducers: {
    initializePosSettings: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPosSettingAsync.fulfilled, (_, action) => {
        return action.payload;
      })
      .addCase(getPosSettingAsync.rejected, () => {
        return initialState;
      });
  },
});

export const { initializePosSettings } = posSettingSlice.actions;

export const posSetting = (state: RootState) => state.posSetting;

export default posSettingSlice.reducer;
